<template>
  <v-dialog persistent :value="dialogShow" :max-width="maxWidth" content-class="box_instant">

    <!--    <v-icon size="30px" :class="['dialog-close-icon white&#45;&#45;text close_instant']" color="white" @click="closeAction" v-if="closeAction != null">mdi-close-circle-outline</v-icon>-->
    <v-card class="dialog-card shoutout-dialog">
      <v-carousel cycle height="auto" interval="1000000" hide-delimiter-background hide-delimiters :show-arrows="arrayInfo.length > 1" show-arrows-on-hover>
        <v-carousel-item v-for="(k, i) in arrayInfo" :key="i">
          <v-sheet height="100%" color="transparent">
            <v-icon :class="['dialog-close-icon']" @click="closeAction" v-if="closeAction != null">mdi-close</v-icon>
            <v-row justify="space-between" no-gutters class="dialog-header pt-1">
              <v-col cols="12" class="px-6 pt-8">
                <label class="full-width font-weight-bold shoutout-dialog-title text-capitalize d-block">{{ k.title }}</label>
              </v-col>
              <v-col cols="12">
                <v-img v-if="resolvedImgUrl(k)" :src="resolvedImgUrl(k)" alt="Dialog Image" max-height="250" contain/>
              </v-col>
              <v-col cols="12" style="text-align: center; padding: 16px;">
                <div style="display: flex; justify-content: center; gap: 10px;">
                  <app-button v-if="k.moreDetails" class="white--text" :action="() => goToLink(k.moreDetails)" custom-class="more-details-button" title="More Details"></app-button>
                  <app-button v-if="k.ctaButtonLink" :action="() => goToLink(k.ctaButtonLink)" custom-class="claim-now-button-yellow" :title="k.ctaButtonText || $t(`label.claimNow`)"></app-button>
                </div>
              </v-col>
            </v-row>
          </v-sheet>
        </v-carousel-item>
      </v-carousel>
    </v-card>
  </v-dialog>
</template>

<script>
import {InboxMsgBonus} from "@/constants/enums/inbox-msg-bonus.enum";

export default {
  name: 'InstantPopupDialog',
  props: {
    arrayInfo: {
      type: Array,
      required: false,
      default: null
    },
    maxWidth: {
      type: Number,
      required: false,
      default: 500
    },
    closeAction: {
      required: false,
      default: null
    },
    dialogShow: {
      type: Boolean,
      required: true,
      default: false
    },
    header_title: {
      type: String,
      required: false
    },
    isAuth: {
      type: Boolean,
      default: false,
      required: false
    },
    showDivider: {
      type: Boolean,
      default: true
    },
    dialogImage: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    minHeight: {
      type: Number,
      required: false,
      default: 500
    },
    customClass: {
      type: String,
      required: false,
      default: 'pa-6 pt-0'
    },
    openRegisterDialog: {
      type: Function,
      default: () => ({})
    },
    openLoginDialog: {
      type: Function,
      default: () => ({})
    },
    isRegSuccess: {
      type: Boolean,
      default: false,
      required: false
    },
    subtitle: {
      type: String,
      required: false,
      default: ''
    },
  },
  methods: {
    goToLink(link) {
      this.closeAction()
      this.$router.push(link).catch(() => {})
    },
    resolvedImgUrl(k) {
      if (k.imgUrl) return k.imgUrl
      const html = k.message || k.content
      if (!html) return null
      const div = document.createElement('div')
      div.innerHTML = html
      const img = div.querySelector('img')
      return img ? img.getAttribute('src') : null
    },
  }
}
</script>

<style>
.box_instant_login {
  height: 450px !important;
  overflow: auto !important;
  box-shadow: none !important;
}

.box_instant {
  overflow-y: auto !important;
  overflow-x: hidden !important;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.close_instant {
  position: absolute;
  width: auto;
  float: right;
  top: 17px;
  right: 2%;
  z-index: 99999;
}

.v-dialog {
  overflow: hidden;
}
.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 95%;
}

.popupImage {
  text-align: center;
}

.popupImage > img {
  text-align: center;
  width: 430px;
  height: auto;
  padding: 5px;
  border-radius: 20px;
}
.popupImage img {
  text-align: center;
  width: 430px;
  height: auto;
  padding: 5px;
  border-radius: 20px;
}

@media (max-width: 750px) {
  .popupImage > img {
    width: 385px;
  }
  .popupImage img {
    width: 385px;
  }
  .close_instant {
    right: 20px;
  }
}

@media (max-width: 450px) {
  .popupImage > img {
    width: 305px;
  }
  .popupImage img {
    width: 305px;
  }
  .close_instant {
    right: 5px;
  }
}

.shoutout-dialog {
  overflow-y: auto !important;

  .v-carousel {
    min-height: 180px;
  }

  .v-carousel__prev,
  .v-carousel__next {
    background-color: rgba(0, 0, 0, 0.2) !important;
    color: white !important;
    .v-icon {
      color: white !important;
    }
  }

  .dialog-close-icon {
    font-size: xx-large;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 9999;
  }

  .v-carousel__controls {
    button {
      background-color: #FFCE01;
    }

    .v-btn--active {
      background-color: #FFCE01;
      color: #FFCE01;
    }
  }

  .shoutout-dot {
    height: 60px;
    width: 100%;
    background-color: transparent !important;
  }

  .claim-now-button-yellow {
    width: 120px !important;
    height: 32px !important;
    background-color: #FFCE01 !important;
    border-radius: 16px !important;
    color: #000000 !important;
  }

  .more-details-button {
    width: 120px !important;
    height: 32px !important;
    background-color: #0080F6 !important;
    border-radius: 16px !important;
  }

  .shoutout-dialog-subtitle {
    font-size: 16px;
    color: #000000 !important;
  }

  .shoutout-dialog-title {
    font-family: 'Roboto', sans-serif;
    font-size: 20px;
    color: #000000 !important;
  }

  .inbox_msg_content {
    font-family: 'Heebo-Medium';
    font-size: 14px;
    text-align: left;
    width: 100%;
    max-width: 100%;
    text-transform: none !important;

    .ql-align-center {
      text-align: center;
    }

    img, image {
      max-width: 100%;
      height: auto;
      display: block;
    }
  }

  .shoutout-image {
    height: 200px;

    div{
      background-size: contain !important;
    }
  }
}
</style>
